import React, { useMemo, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import ReactTableGenericForUsers from "Components/ReactTableGenericForUsers";
import GroupStatus from "Components/IconDropdown/Cross_Tick/GroupStatus";
import { Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { useUpdateAnonymize } from "Api/Admin/Anonimiseren";
import { debounce } from "helperFunctions";

const Table = (props) => {
    const [loadingKeys, setLoadingKeys] = useState({});
    const [searchValue, setSearchValue] = useState("");

    const { trigger: updateAnonymize } = useUpdateAnonymize();
    const paginate = (val) => {
        props.setPageNumber(val);
    };

    const handleInputChange = useMemo(
        () =>
            debounce((val) => {
                props.setPageNumber(1);
                props.setSearch(val);
            }, 500),
        [props.setPageNumber, props.setSearch],
    );

    const filterList = (val) => {
        if (val === searchValue) {
            return;
        }
        setSearchValue(val);
        handleInputChange(val);
    };

    const indexPageSize = (val) => {
        props.setPageSizeCount(val);
    };

    const userTablePageSize = (val) => {
        props.setPageNumber(1);
        indexPageSize(val);
    };

    const columns = [
        {
            header: "Contracttype",
            accessorKey: "abbr",
        },
        {
            header: "Bestuur",
            accessorKey: "vCommunityName",
        },
        {
            header: <div className="text-center">Anonimiseren</div>,
            accessorKey: "not_faked",
            cell: (value) => {
                return <div className="cursor-pointer ms-2">
                    {
                        loadingKeys[value.row?.original.id] ? (
                            <div className="spinner-icon-change">
                                <div><Spinner size="sm" color="primary" /></div>
                            </div>
                        ) :
                            (
                                <GroupStatus iconChangeHandler={(field, data) => toggleIconHandler(value.row.original, value.row.original?.iCommunityId, value.row.original?.id, data)} data={value.row?.original.not_faked ? 0 : 1} />
                            )
                    }
                </div>

            },
        }
    ];

    const toggleIconHandler = async (
        rowData,
        communityId,
        id,
        data
    ) => {
        const changesExist = props.anonymizeLists.some(item => {
            return item.id === id && item.not_faked === parseInt(data);
        });

        if (changesExist) {
            setLoadingKeys(prevLoadingKeys => {
                const updatedLoadingKeys = Object.fromEntries(
                    Object.entries(prevLoadingKeys).filter(([_, value]) => value !== false)
                );

                return { ...updatedLoadingKeys, [rowData.id]: true };
            });
            const values = {
                id: id,
                community_id: communityId,
                notFaked: parseInt(data) ? 0 : 1
            };
            try {
                const response = await updateAnonymize({
                    data: values,
                });

                if (response?.status || response?.data?.status) {
                    props.mutate();
                } else {
                    toast.dismiss();
                    toast.error("Kan niet updaten");
                }
            } catch (error) {
                toast.dismiss();
                toast.error("Kan niet updaten");
            } finally {
                setLoadingKeys(prev => ({
                    ...prev,
                    [rowData.id]: false,
                }));
            }
        };
    }

    return (
        <>
            <ReactTableGenericForUsers
                data={props.anonymizeLists}
                columns={columns}
                setPageNumber={props.setPageNumber}
                pageNumber={props.pageNumber}
                totalPageCount={props.totalPageCount}
                filters={{ search: true }}
                paginate={paginate}
                filterList={filterList}
                userTablePageSize={userTablePageSize}
                pageSizeCount={props.pageSizeCount}
                showLoader={props.showLoader}
                count={props.count}
                tableClassName="mb-0 table table-borderless table-sm table-hover table-heading-style "
            />
        </>
    );
};

export default Table;